import elbil from '../assets/images/Pins/desktop/elbil.svg'
import elbilMobile from '../assets/images/Pins/mobile/elbil.svg'

export const STICKERS = {
  Elbil: {
    desktop: elbil,
    mobile: elbilMobile
  }
}
